import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import DepartmentBlogTile from './department-blog-tile';

const CompanyEngBlog = ({ posts }) => {
  const renderedPosts = _.map(posts, (post) => (
    <DepartmentBlogTile {...post} key={`item-${post.id}`} />
  ));

  return (
    <div>
      <div
        className={classNames([
          'eng-blog__cont',
          classes('margin-horizontal-auto'),
          classes('padding-vertical-0'),
          classes('padding-horizontal-3--wide'),
          classes('display-flex--wide'),
          classes('flex-direction-row--wide'),
          classes('flex-wrap--wide'),
        ])}
      >
        {renderedPosts}
      </div>
    </div>
  );
};

CompanyEngBlog.displayName = 'Company Engineering Blog';

CompanyEngBlog.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape(DepartmentBlogTile.propTypes)),
};

export default CompanyEngBlog;
